import { DocumentType } from '@/classes/generated-models'

export function EnumToArray(value: any): Array<{ key: string; value: string }> {
  return Object.keys(value)
    .map(key => ({ key: key.toUpperCase(), value: key }))
    .filter(locale => locale.key.toLowerCase() !== 'unknown')
}

export function documentPrimaryName(documentType: DocumentType): string {
  switch (documentType) {
    case DocumentType.Certificates:
      return 'DOCUMENTS.CERTIFICATE_NUMBER'
    case DocumentType.Invoices:
      return 'DOCUMENTS.INVOICE_NUMBER'
    case DocumentType.PackingSlips:
      return 'DOCUMENTS.PACKING_SLIP_NUMBER'
    case DocumentType.SalesAgreements:
      return 'DOCUMENTS.ROBA_NUMBER'
    case DocumentType.SalesOrders:
      return 'DOCUMENTS.ROBA_NUMBER'
    default:
      return ''
  }
}

export function documentSecondaryName(documentType: DocumentType): string {
  switch (documentType) {
    case DocumentType.Certificates:
      return 'DOCUMENTS.BATCH_NUMBER'
    case DocumentType.Invoices:
      return 'COMMON.DATE'
    case DocumentType.PackingSlips:
      return 'COMMON.DATE'
    case DocumentType.SalesAgreements:
      return 'DOCUMENTS.EXTERNAL_CUSTOMER_REFERENCE'
    case DocumentType.SalesOrders:
      return 'DOCUMENTS.EXTERNAL_CUSTOMER_REFERENCE'
    default:
      return ''
  }
}
